import { isDesktop } from 'react-device-detect';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AnimalsByGroup, Percentile, SampleStatus } from './interfaces';

const initialState: SampleStatus = {
  showAnimalsRemoved: true,
  percentileList: [],
  showQuantityAnimalsPanel: isDesktop,
  showModal: false,
};

export const sampleSlice = createSlice({
  name: 'sample',
  initialState,
  reducers: {
    setShowAnimalsRemoved: (state: SampleStatus, action: PayloadAction<boolean>) => {
      state.showAnimalsRemoved = action.payload;
    },
    setPercentileList: (state: SampleStatus, action: PayloadAction<Percentile[] | AnimalsByGroup[]>) => {
      state.percentileList = action.payload;
    },
    setShowQuantityAnimalsPanel: (state: SampleStatus, action: PayloadAction<boolean>) => {
      state.showQuantityAnimalsPanel = action.payload;
    },
    setShowModal: (state: SampleStatus, action: PayloadAction<boolean>) => {
      state.showModal = action.payload;
    },
  },
});

export const {
  setShowAnimalsRemoved,
  setPercentileList,
  setShowQuantityAnimalsPanel,
  setShowModal,
} = sampleSlice.actions;

export default sampleSlice.reducer;
